/* global axios */

import ApiClient from './ApiClient';

// Additive API client for the Availability RBAC feature.
// Backend: lib/core_extensions/availability_agents_controller_extension.rb
class AvailabilityManagerAPI extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  // Roster of agents with their availability + lock state.
  getAvailabilityLocks() {
    return axios.get(`${this.url}/availability_locks`);
  }

  // Company-wide policy: when supervisor_managed is true, agents cannot
  // change their own availability.
  getAvailabilityPolicy() {
    return axios.get(`${this.url}/availability_policy`);
  }

  updateAvailabilityPolicy(supervisorManaged) {
    return axios.put(`${this.url}/availability_policy`, {
      supervisor_managed: supervisorManaged,
    });
  }

  // availability: 'online' | 'offline' | 'busy'
  // locked: boolean — when true the agent cannot change their own status
  setAgentAvailability(agentId, { availability, locked }) {
    return axios.put(`${this.url}/${agentId}/set_availability`, {
      agent: { availability, locked },
    });
  }
}

export default new AvailabilityManagerAPI();
